import { Store, Gift, MapPin } from 'lucide-react'

const reasons = [
  {
    icon: Store,
    title: 'Straight from the shop',
    text: "Menus, prices and stock come from the shop's own till, so what you see is what they have. Your order goes directly to the people making it.",
  },
  {
    icon: Gift,
    title: 'One app, every local reward',
    text: 'No more stacks of loyalty cards. Your points from every participating shop live in one place, ready to redeem.',
  },
  {
    icon: MapPin,
    title: 'Local comes first',
    text: 'Nearbies only shows shops close to you - the cafés, grocers and restaurants on your own doorstep.',
  },
]

const WhyNearbies = () => (
  <section className="py-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Why people love Nearbies</h2>
        <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
          Built for neighbourhoods, not for national chains.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {reasons.map(({ icon: Icon, title, text }) => (
          <div key={title} className="bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 rounded-xl bg-primary-600 text-white flex items-center justify-center mb-5 shadow-md">
              <Icon className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default WhyNearbies
